<ng-content select="[pre]"></ng-content>
<ng-container *ngFor="let section of list">
    <ng-container *lazyLoad="section?.alias; data: section; error: error"></ng-container>
    <ng-template #error>List Element Not Found: {{ section?.alias }}</ng-template>
</ng-container>
<ng-content select="[post]"></ng-content>
